import React, { useContext, useState } from "react";
import { TextField, MenuItem,Button } from "@mui/material";
import { ContextData } from "../../../../../context/Context";
import axios from "axios";
import { toast } from "react-toastify";
import baseUrl from "../../../../../BaseURL";
import SoundAlert from "../../../../../routes/SoundAlert";


function SocialInfo({ formData, handleChange }) {


  const {UserTokens,ReloadBioForms,setReloadBioForms} = useContext(ContextData)
  const [facebook_handle,setfacebook_handle] = useState(formData.social_info.facebook_handle || "")   
  const [instergram_handle,setinstergram_handle] = useState(formData.social_info.instergram_handle || "")
  const [twitter_handle,settwitter_handle] = useState(formData.social_info.twitter_handle || "")
  
   

    // Handle data to server if succeed
 const handleSubmit = (va,e) => {
    
  e.preventDefault()

  
    if(va === "facebook_handle"){
    if ( facebook_handle.trim() === "" ) {
            SoundAlert("error")
      toast.error('Please fill in all required fields.');
        return
    }
   }

   if(va === "instergram_handle"){ 
    if ( instergram_handle.trim() === "" ) {
            SoundAlert("error") 
      toast.error('Please fill in all required fields.');
        return
    }
   }

   if(va === "twitter_handle"){ 
    if ( twitter_handle.trim() === "" ) {
          SoundAlert("error")   
      toast.error('Please fill in all required fields.');
        return
    }
   }

   
    const data = {
      facebook_handle: facebook_handle,
      instergram_handle: instergram_handle,
      twitter_handle: twitter_handle,
      user_token: UserTokens
    } 
    
    axios.put(`${baseUrl}/auth/social_media_update`,data,{
      withCredentials: true,
      headers: {
        'Accept' : 'application/json'
      }}).then(res=>{

        
       if(res.data.status){
          SoundAlert("success")
        toast.success(res.data.textStatus);
         setReloadBioForms(!ReloadBioForms)
          }
      

      }).catch(err=> {
          if(err){
              
            toast.error(err.message)
            console.log(err)
            return

          }   
      })


 
}



  return (
    <div>


      
      <TextField
        label="Facebook Handle"
        name="facebook_handle"
        value={facebook_handle}
        onChange={(e)=> setfacebook_handle(e.target.value)}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button
              variant="outlined"
              color="secondary"
             onClick={(e) => handleSubmit("facebook_handle",e)}
               
            >
              Save
            </Button>
          )
        }}
      />



      <TextField
        label="Instagram Handle"
        name="instergram_handle"
        value={instergram_handle}
        onChange={(e)=> setinstergram_handle(e.target.value)}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button
              variant="outlined"
              color="secondary"
             onClick={(e) => handleSubmit("instergram_handle",e)}
               
            >
              Save
            </Button>
          )
        }}
      />

      <TextField
        label="Twitter Handle"
        name="twitter_handle"
        value={twitter_handle}
        onChange={(e)=> settwitter_handle(e.target.value)}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button
              variant="outlined"
              color="secondary"
             onClick={(e) => handleSubmit("twitter_handle",e)}
               
            >
              Save
            </Button>
          )
        }}
      />


     

    </div>
  );
}

export default SocialInfo;
